import React, { useState } from 'react';
import axios from 'axios';
import { Modal, Box, IconButton } from '@mui/material';
import { FaTimes } from 'react-icons/fa';
import BtnLoader from 'Components/Common/Loader/BtnLoader';
import { loadDecrypted } from "Common Usage/localStorageUtils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 400,
    bgcolor: 'background.paper',
    borderRadius: 8,
    boxShadow: 24,
    p: 4,
    textAlign: 'center',
};

const DeleteUserpopup = ({ deleteUserModal, handleDeleteModalClose, userDetails, fetchUsers }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDelete = async () => {
        setIsLoading(true);
        setError(null);

        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/users/delete/${userDetails?._id}`);
            
            // ─────────────────────────────────────────────────────────
            // Create staff activity log for user deletion
            // ─────────────────────────────────────────────────────────
            try {
                const staffData = loadDecrypted("HeartConnect-StaffData");
                const staffId = staffData?._id || staffData?.id || "";
                const staffName = staffData?.fullName || staffData?.name || "Unknown";

                if (staffId) {
                    await axios.post(
                        `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
                        {
                            staff: staffId,
                            action: "DELETE_USER",
                            description: `Staff ${staffName} deleted user ${userDetails?.fullName} (${userDetails?._id})`,
                        },
                        { headers: { "Content-Type": "application/json" } }
                    );
                }
            } catch (logErr) {
                console.error("Failed to create staff activity log:", logErr);
            }
            // ─────────────────────────────────────────────────────────

            fetchUsers();
            handleDeleteModalClose();
        } catch (err) {
            setError(err?.response?.data?.message || 'Failed to delete user. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={deleteUserModal}
            onClose={handleDeleteModalClose}
            aria-labelledby="delete-user-modal-title"
        >
            <Box sx={style}>
                <IconButton
                    aria-label="close"
                    onClick={handleDeleteModalClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#c51369',
                    }}
                >
                    <FaTimes />
                </IconButton>

                <h2 className="text-xl font-semibold text-navy-700 mb-4">Confirm Delete</h2>
                <p className="text-gray-600 mb-6">
                    Are you sure you want to delete <strong>{userDetails?.fullName}</strong>?
                </p>

                {error && <p className="text-red-500 mb-4">{error}</p>}

                <div className="flex justify-center gap-4">
                    <button
                        onClick={handleDeleteModalClose}
                        className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded-md"
                        disabled={isLoading}
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleDelete}
                        className="bg-[#c51369] hover:bg-[#a10f5b] text-white px-4 py-2 rounded-md"
                        disabled={isLoading}
                    >
                        {isLoading ? <BtnLoader /> : 'Confirm'}
                    </button>
                </div>
            </Box>
        </Modal>
    );
};

export default DeleteUserpopup;






// import React, { useState } from 'react';
// import axios from 'axios';
// import { Modal, Box, IconButton } from '@mui/material';
// import { FaTimes } from 'react-icons/fa';
// import BtnLoader from 'Components/Common/Loader/BtnLoader';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%',
//     maxWidth: 400,
//     bgcolor: 'background.paper',
//     borderRadius: 8,
//     boxShadow: 24,
//     p: 4,
//     textAlign: 'center',
// };

// const DeleteUserpopup = ({ deleteUserModal, handleDeleteModalClose, userDetails, fetchUsers }) => {
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const handleDelete = async () => {
//         setIsLoading(true);
//         setError(null);

//         try {
//             await axios.delete(`${process.env.REACT_APP_API_URL}/users/delete/${userDetails?._id}`);
//             fetchUsers();
//             handleDeleteModalClose();
//         } catch (err) {
//             setError(err?.response?.data?.message || 'Failed to delete user. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <Modal
//             open={deleteUserModal}
//             onClose={handleDeleteModalClose}
//             aria-labelledby="delete-user-modal-title"
//         >
//             <Box sx={style}>
//                 <IconButton
//                     aria-label="close"
//                     onClick={handleDeleteModalClose}
//                     sx={{
//                         position: 'absolute',
//                         right: 8,
//                         top: 8,
//                         color: '#c51369',
//                     }}
//                 >
//                     <FaTimes />
//                 </IconButton>

//                 <h2 className="text-xl font-semibold text-navy-700 mb-4">Confirm Delete</h2>
//                 <p className="text-gray-600 mb-6">
//                     Are you sure you want to delete <strong>{userDetails?.fullName}</strong>?
//                 </p>

//                 {error && <p className="text-red-500 mb-4">{error}</p>}

//                 <div className="flex justify-center gap-4">
//                     <button
//                         onClick={handleDeleteModalClose}
//                         className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded-md"
//                         disabled={isLoading}
//                     >
//                         Cancel
//                     </button>

//                     <button
//                         onClick={handleDelete}
//                         className="bg-[#c51369] hover:bg-[#a10f5b] text-white px-4 py-2 rounded-md"
//                         disabled={isLoading}
//                     >
//                         {isLoading ? <BtnLoader /> : 'Confirm'}
//                     </button>
//                 </div>
//             </Box>
//         </Modal>
//     );
// };

// export default DeleteUserpopup;
